import { Autocomplete, Box, Chip, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { getCourseAvailable } from '../../redux/features/batchSlice';
import { useDispatch } from 'react-redux';
import GlobalSelectField from '../../components/mui/GlobalSelectField';
import CourseCard from './CourseCard';

const ProjectCourses = () => {

const {  allcourses } = useSelector((state) => state.batch);

const [course, setSelectedCourse] = useState("")

const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getCourseAvailable());
  }, []);

  const handlecourses = (e,option) =>{
    setSelectedCourse(option?.course_available_id || "")
  }

  const statuses = [
    {id:1,status:"Active"},
    {id:2,status:"Inactive"}
  ]

  return (
    <>
      <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: 3,
                borderRadius: 2,
                mb: 3,
                gap:2
              }}
            >
              <Box
                component="img"
                src="https://www.intervaledu.com/static/web/images/logo/logo-dark.png"
                alt="Example"
                sx={{
                  width: "auto",
                  height: 100,
                  objectFit: "contain",
                }}
              />
              <Box sx={{
                borderRadius:5,
                border: '1px solid #A125C2',
                px:2,
                color:'#A125C2',
                py:0.5
              }}>
                Little Genie
              </Box>
            </Box>
            <Box>
          <Grid container spacing={3}>
          <Grid item xs={12} md={6} sm={6}>
             <Autocomplete
                          name="Courses"
                          fullWidth
                          options={allcourses}
                          getOptionLabel={(option) => option.course_name || ""}
                          onChange={handlecourses}
                          value={allcourses.find((courseOption) => courseOption.course_available_id === course) || ""}
                          renderInput={(params) => <TextField disabled fullWidth autoComplete="off" {...params} label="Courses" />}
                        />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
                          <GlobalSelectField
                options={{
                  name: "course_status",
                  label: "Status",
                  data: statuses,
                  keys: {
                    id: "id",
                    value: "status",
                  },
                  sx: { width: "100%" },
                }}
              />
          </Grid>
          </Grid>
            </Box>
            <Box mt={3}>
                <CourseCard/>
            </Box>
    </>
  )
}

export default ProjectCourses
